<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="col-md-12">
          <form class="form-inline">
            <div class="form-group">
              <label
                class="control-label"
                for="new_field"
              >
                {{ trans('schedule_sync_rules.actions.new_action') }}
              </label>
              <select
                id="new_field"
                v-model="action_field"
                class="form-control"
              >
                <option v-for="(option, index) in ['name', 'groups', 'lecturers', 'classrooms']">
                  {{ option }}
                </option>
              </select>
            </div>

            <button
              class="btn btn-default"
              type="button"
              @click="addAction(action_field)"
            >
              <i class="fa fa-plus" /> {{ trans('schedule_sync_rules.actions.add_action') }}
            </button>
          </form>
        </div>
        <div
          v-for="(action, order) in actions"
          class="col-md-12"
        >
          <create-sync-action
            :field="action.field"
            :order="order"
            @remove_action="removeAction(order)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreateSyncAction from './CreateSyncAction.vue'
import { mapGetters } from 'vuex'
import toast from '../../../services/toast'

export default {
  components: {
    CreateSyncAction,
  },
  props: {
    formValues: {
      required: true,
      type: Object,
    },
  },

  data () {
    return {
      url: 'preview-actions',
      action_field: '',
      actions_validate: false,
    }
  },

  computed: {
    canContinue () {
      // todo At least 1 action
      // todo all added actions are completed
      // validate each action, if all are ok: can continue!
      return this.actions_validate
    },
    ...mapGetters([
      'actionObj',
      'actionsFilled',
    ]),

    actions () {
      return this.$store.state.scheduleSync.actions
    },

    event_ids () {
      return this.$store.state.scheduleSync.event_ids
    },
  },

  watch: {
    currentStep: function (val) {
      // if this value changes: it means this component has come in to focus in the stepper component
      this.emitContinue()
    },
    actions: {
      handler: function (actions) {
        // wait until after the validation before continuing
        this.$emit('canNotFinishStep')

        // if the user finished filling in the action, start validating
        if (this.actionsFilled) {
          // if someone changes the action, check if they are valid or not
          this.debouncedValidateActions()
        }
      },
      deep: true,
    },
  },

  mounted () {
    this.emitContinue()
  },

  methods: {
    emitContinue () {
      if (this.canContinue) {
        this.$emit('canFinishStep')
      } else {
        this.$emit('canNotFinishStep')
      }
    },

    addAction (field) {
      // would be nice to support drag-and-drop reordering
      // currently, the order is just given by the order of when the actions are added
      this.$store.dispatch('add_action', { field })
    },

    removeAction (order) {
      this.$store.dispatch('remove_action', order)
    },

    debouncedValidateActions: _.debounce(function () {
      // try to load preview actions
      // todo: if success, we can save them to the store, so we don't have to
      // todo: send a request again
      axios.post(
        this.url,
        {
          actions: this.actionObj,
          event_ids: this.event_ids,
          program_id: this.formValues.programId,
        },
        { errorHandle: false },
      ).then((response, something) => {
        this.actions_validate = true
        this.$store.dispatch('clear_errors')
        this.emitContinue()
      }).catch(error => {
        this.actions_validate = false

        if (error.response && error.response.status === 422) {
          this.$store.dispatch('set_errors', error.response.data)
          toast.error(Lang.get('errors.message.validation'))
          this.actions_validate = false
        } else {
          toast.error(Lang.get('errors.message.generalerror'))
        }

        this.emitContinue()
      })
    }, 1000),
  },
}
</script>
